import React from 'react'
import { Field } from '@ztechapps/webui.form'
import { ProductSelect, QuantityInputWithUom } from '@ztechapps/product.webui'
import { precisionStep } from '@ztechapps/common.utils'
import { Stack } from 'react-bootstrap'
import { useFormikContext } from 'formik'
import type { AdjustmentAddFormValues } from './Context'

export const AdjustmentAddFormInput = () => {
  const { values } = useFormikContext<AdjustmentAddFormValues>()
  const uomSymbol = values?.product?.baseUom?.symbol
  const uomStep = precisionStep(values?.product?.unitOfMeasurePrecision ?? 0)

  return (
    <Stack gap={3}>
      <div>
        <Field
          label="Product to adjust"
          name="product"
          component={ProductSelect}
          onChange
          placeholder="Select a product to adjust."
          autoFocus
        />
      </div>
      <div>
        <Field
          label="Quantity to adjust"
          name="quantity"
          component={QuantityInputWithUom}
          symbol={uomSymbol}
          step={uomStep}
        />
      </div>
    </Stack>
  )
}
